import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Team, TeamCard } from 'src/app/core/models/project-pilot.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { ManageTeamComponent } from '../team/manage-team/manage-team.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Context } from 'src/app/shared/models/context';
import { DataService } from 'src/app/shared/services/data.service';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { TeamsComponent } from '../team/teams/teams.component';

@Component({
  selector: 'app-team-insight',
  templateUrl: './team-insight.component.html',
  styleUrls: ['./team-insight.component.scss']
})
export class TeamInsightComponent implements OnInit {
  public team: Team[] = [];
  public isLoading: boolean = true;
  public count = 3;
  public employeeCount!: number;
  public teamCard: TeamCard;
  public privilege: PrivilegeType;
  public context: Context;
  private subscription: any;



  constructor(
    private projectPilotService: ProjectPilotService,
    private commonService: CommonService,
    private authService: AuthService,
    private dataService: DataService,
    private modalService: NgbModal


  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.subscription = this.authService.getContext().subscribe(context => {
      this.context = context;
      if (context.teamId) {
        this.getTeamCard();
      }
    });
    this.getTeamInsights();
  }

  public getTeamInsights(clear: boolean = true) {
    this.projectPilotService.getTeamInsights(this.count, true).subscribe({
      next: (team: Team[]) => {
        this.team = team;
        this.isLoading = false;
        this.employeeCount = team.reduce((total, teamItem) => {
          return total + (teamItem.teamMembersDto ? teamItem.teamMembersDto.length : 0);
        }, 0);
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public getTeamCard() {
    this.projectPilotService.getTeamCard(this.context.teamId).subscribe({
      next: (team: TeamCard) => {
        this.teamCard = team;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.commonService.setToastr(500, error?.error?.name || error.error);
        this.isLoading = false;
      }
    });
  }

  public createTeam(team?: Team) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ManageTeamComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.team = team;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
